<template>
    <div class="venue-profile-component" :class="{'venue-profile-component--gold':isGoldUser(user),
    'venue-profile-component--gold--has-header':isGoldUser(user) && getProfileBannerUrl(user)}">

        <div class="profile-loading-container" v-if="!user">
            <div class="col-12 justify-content-center loading-spinner">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ translate.home.loading }}...</span>
                </div>
                <span>{{ translate.home.loading }}...</span>
            </div>
        </div>

        <modal-blurred-profile v-if="blurLockedProfile" :profile-user="user"
                               ref="modalBlurredProfile"></modal-blurred-profile>

        <ModalPunterLoginOrRegisterComponent></ModalPunterLoginOrRegisterComponent>

        <inactive-profile-banner v-if="profileIsInactive && !this.isGoldUser(user)"
                                 :user="user"></inactive-profile-banner>

        <div v-if="user && user.breadcrumbs"
             class="profile-breadcrumbs d-none d-sm-block"
             :class="{'no-border': isGoldUser(user) && getProfileBannerUrl(user)}">
            <ProfileBreadcrumbsComponent :user='user'/>
        </div>

        <div class="venue-profile-gold-header" v-if="isGoldUser(user) && getProfileBannerUrl(user)">
            <picture>
                <source :srcset="getProfileBannerUrl(user,'webp')"
                        class="lazyload-src" type="image/webp">
                <source :srcset="getProfileBannerUrl(user,'jpg')"
                        class="lazyload-src" type="image/jpeg">
                <img :src="getProfileBannerUrl(user,'jpg')" alt="header image">
            </picture>
        </div>

        <ProfileHeaderNavigationComponent
            :class="{'transparent': isGoldUser(user) && getProfileBannerUrl(user)}"
            :show-location="areUserCoordinatesSet"
            :show-reviews="true"
            :show-about="!!getAboutMe()"
        />

        <div class="row limit-profile-page-width user-profile-component-content venue-profile-content" v-show="user"
             :class="{ 'limit-profile-page-width--inactive':profileIsInactive,
                       'has-header-image': isGoldUser(user) && getProfileBannerUrl(user)}">

            <div class="col-md-12" v-if="isUserAdmin">
                <div class="outcall-locations-container limit-profile-page-width mb-3 d-flex p-2 align-items-baseline">
                    <span>Search locations this venue appears in: {{ outcallLocationsForAdmin }}</span>
                </div>
            </div>

            <modal-report-profile :reported-user-id="user ? user.id : 0"></modal-report-profile>
            <ModalWriteReviewComponent :user="user" @reviewCreated="onReviewCreated"></ModalWriteReviewComponent>

            <div class="col-md-12 mb-4">
                <div class="main-profile-container container-box-desktop">
                    <!--   Photos start   -->
                    <div class="venue-regular-photos-wrapper" v-if="!isGoldUser(user)"
                         :class="{'visibility-hidden': !user}">
                        <div id="profile-image-slider" class="carousel slide" data-ride="carousel">

                            <span v-if="photosToShow.length > 0" class="profile-image-wrapper">

                    <div class="carousel-indicator-wrapper">
                        <span v-if="showScrollArrows" @click="carouselPrev()"
                              class="carousel-arrow-indicator carousel-arrow-indicator--up">
                                <icon-component :icon="fa_angle_up()"></icon-component>
                        </span>

                        <ol class="carousel-indicators">
                            <template
                                v-for="(photo,i) in photosToShow">

                                <!-- Regular video -->
                                <li
                                    v-if="photo.video_id"
                                    :key="i"
                                    :class="[{active:i===0},'carousel-indicator-item-'+i]"
                                    :data-slide-to="i"
                                    data-target="#profile-image-slider">
                                        <picture v-if="!isMediaExplicit(photo)" e2e-id="profile-photo-thumbnail"
                                                 class="position-relative">
                                            <source :srcset="getVideoThumbnailUrl(user,'webp','p-small', photo)"
                                                    type="image/webp">
                                            <source :srcset="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                    type="image/jpeg">
                                            <img class="d-block"
                                                 :src="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                 @load="initializePhotoScroll" :alt="'Video #' + (i + 1)"
                                                 width="87" height="116"/>

                                            <div class="profile-video-container">
                                                <div class="profile-video-block">
                                                    <button class="profile-video-button">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                             fill="currentColor" aria-hidden="true">
                                                            <path
                                                                d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </picture>
                                        <explicit-photo-placeholder v-else
                                                                    class="explicit-photo-placeholder--thumbnail"
                                                                    e2e-id="profile-photo-thumbnail-explicit"
                                                                    :show-action-buttons="false"/>

                                </li>
                                <!-- Regular video end-->

                                <li v-else :key="i" :class="[{active:i===0},'carousel-indicator-item-'+i]"
                                    data-target="#profile-image-slider" :data-slide-to="i">
                                      <picture v-if="!isMediaExplicit(photo)" e2e-id="profile-photo-thumbnail">
                                          <source :srcset="getPhotoUrl(user,'webp','small',i)" type="image/webp">
                                          <source :srcset="getPhotoUrl(user,'jpg','small',i)" type="image/jpeg">
                                          <img class="d-block" :src="getPhotoUrl(user,'jpg','small',i)"
                                               @load="initializePhotoScroll"
                                               :alt="'Photo #'+(i+1)" width="87" height="116"/>
                                      </picture>
                                      <explicit-photo-placeholder v-else
                                                                  class="explicit-photo-placeholder--thumbnail"
                                                                  e2e-id="profile-photo-thumbnail-explicit"
                                                                  :show-action-buttons="false"/>
                                </li>
                            </template>
                        </ol>

                        <span v-if="showScrollArrows"
                              class="carousel-arrow-indicator carousel-arrow-indicator--down"
                              @click="carouselNext">
                                <icon-component :icon="fa_angle_down()"></icon-component>
                        </span>
                    </div>

                    <div class="carousel-inner">
                        <div v-for="(photo,i) in photosToShow" class="carousel-item" :class="{active:i===0}" :key="i"
                             @click="openFancyBox(i, photo)">
                            <explicit-photo-placeholder v-if="isMediaExplicit(photo)"
                                                        verificationOrigin="gallery"
                                                        :profileUserId="user.id"
                                                        class="explicit-photo-placeholder--profile"
                                                        e2e-id="profile-photo-explicit">
                            </explicit-photo-placeholder>

                            <template v-else-if="photo.video_id">
                                <picture e2e-id="profile-video" class="video-block">
                                    <source media="(min-width:300px)" type="image/webp"
                                            :srcset="getVideoThumbnailUrl(user,'webp','medium',photo)">
                                    <source media="(max-width:300px)" type="image/webp"
                                            :srcset="getVideoThumbnailUrl(user,'webp','50',photo)">
                                    <source :srcset="getVideoThumbnailUrl(user,'webp','25',photo)" type="image/webp">

                                    <source media="(min-width:300px)" type="image/jpeg"
                                            :srcset="getVideoThumbnailUrl(user,'jpg','medium',photo)">
                                    <source media="(max-width:300px)" type="image/jpeg"
                                            :srcset="getVideoThumbnailUrl(user,'jpg','50',photo)">
                                    <source :srcset="getVideoThumbnailUrl(user,'jpg','25',photo)" type="image/jpeg">

                                    <img :src="getVideoThumbnailUrl(user,'jpg','medium',photo)" :alt="'Video #'+(i+1)">

                                    <div class="profile-video-container">
                                        <div class="profile-video-block">
                                            <button class="profile-video-button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path
                                                        d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </picture>
                            </template>

                            <picture v-else e2e-id="profile-photo">
                                <source media="(min-width:300px)" type="image/webp"
                                        :srcset="getPhotoUrl(user,'webp','',i, true)">
                                <source media="(max-width:300px)" type="image/webp"
                                        :srcset="getPhotoUrl(user,'webp','50',i, true)">
                                <source :srcset="getPhotoUrl(user,'webp','25',i, true)" type="image/webp">

                                <source media="(min-width:300px)" type="image/jpeg"
                                        :srcset="getPhotoUrl(user,'jpg','',i, true)">
                                <source media="(max-width:300px)" type="image/jpeg"
                                        :srcset="getPhotoUrl(user,'jpg','50',i, true)">
                                <source :srcset="getPhotoUrl(user,'jpg','25',i, true)" type="image/jpeg">

                                <img :src="getPhotoUrl(user,'jpg','',i, true)" :alt="'Photo #'+(i+1)">
                            </picture>
                        </div>

                    </div>
                    </span>
                            <span v-else class="profile-image-wrapper">
                        <div class="carousel-inner w-100">
                                <div class="carousel-item active">
                                    <img class="d-block w-100" :src="noPhotoUrl" alt="First slide">
                                </div>
                        </div>
                    </span>

                        </div>

                    </div>
                    <!--   Photos end   -->

                    <!-- GOLD  Photos start GOLD   -->
                    <div class="venue-gold-photos-wrapper" v-if="isGoldUser(user)"
                         :class="{'visibility-hidden': !user}">
                        <div id="profile-image-slider" class="carousel slide" data-ride="carousel">

                            <span v-if="photosToShow.length > 0" class="profile-image-wrapper">

                        <div class="carousel-inner">

                            <div v-for="(photo,i) in photosToShow" class="carousel-item" :class="{active:i===0}"
                                 :key="i" @click="openFancyBox(i, photo)">
                                <explicit-photo-placeholder v-if="isMediaExplicit(photo)"
                                                            verificationOrigin="gallery"
                                                            :profileUserId="user.id"
                                                            class="explicit-photo-placeholder--profile  explicit-photo-placeholder--profile--horizontal"
                                                            e2e-id="profile-photo-explicit">
                                </explicit-photo-placeholder>

                                <template v-else-if="photo.video_id">
                                    <picture e2e-id="profile-video" class="video-block">
                                        <source :srcset="getVideoThumbnailUrl(user,'webp','p-small', photo)"
                                                type="image/webp">
                                        <source :srcset="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                type="image/jpeg">
                                        <img class="d-block" :src="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                             :alt="'Video #' + (i + 1)">

                                        <div class="profile-video-container">
                                            <div class="profile-video-block">
                                                <button class="profile-video-button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                         fill="currentColor" aria-hidden="true">
                                                        <path
                                                            d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </picture>
                                </template>

                                <picture v-else e2e-id="profile-photo">
                                    <source media="(min-width:300px)" type="image/webp"
                                            :srcset="getPhotoUrl(user,'webp','l-',i)">
                                    <source media="(max-width:300px)" type="image/webp"
                                            :srcset="getPhotoUrl(user,'webp','l-50',i)">
                                    <source :srcset="getPhotoUrl(user,'webp','l-25',i)" type="image/webp">

                                    <source media="(min-width:300px)" type="image/jpeg"
                                            :srcset="getPhotoUrl(user,'jpg','l-',i)">
                                    <source media="(max-width:300px)" type="image/jpeg"
                                            :srcset="getPhotoUrl(user,'jpg','l-50',i)">
                                    <source :srcset="getPhotoUrl(user,'jpg','l-25',i)" type="image/jpeg">

                                    <img :src="getPhotoUrl(user,'jpg','l-',i)" :alt="'Photo #'+(i+1)">
                                </picture>
                            </div>
                        </div>

                        <div class="carousel-indicator-wrapper mt-md-2">
                            <ol class="carousel-indicators-venue-gold-profile">
                                <li v-for="(photo,i) in photosToShow" :key="i" :class="'carousel-indicator-item-'+i"
                                    v-if="i > 0 && i < 4" @click="openFancyBox(i, photo)">
                                    <explicit-photo-placeholder v-if="isMediaExplicit(photo)"
                                                                class="explicit-photo-placeholder--thumbnail venue"
                                                                e2e-id="profile-photo-thumbnail-explicit"
                                                                :show-action-buttons="false"/>
                                    <template v-else-if="photo.video_id">
                                        <picture e2e-id="profile-video" class="video-block">
                                            <source :srcset="getVideoThumbnailUrl(user,'webp','p-small', photo)"
                                                    type="image/webp">
                                            <source :srcset="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                    type="image/jpeg">
                                            <img class="d-block"
                                                 :src="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                 width="180" height="120"/>

                                            <div class="profile-video-container">
                                                <div class="profile-video-block">
                                                    <button class="profile-video-button">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                             fill="currentColor" aria-hidden="true">
                                                            <path
                                                                d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </picture>
                                    </template>
                                    <picture v-else e2e-id="profile-photo-thumbnail">
                                      <source :srcset="getPhotoUrl(user,'webp','l-small',i)" type="image/webp">
                                      <source :srcset="getPhotoUrl(user,'jpg','l-small',i)" type="image/jpeg">
                                      <img class="d-block w-100" :src="getPhotoUrl(user,'jpg','l-small',i)"
                                           :alt="'Photo #'+(i+1)" width="180" height="120"/>
                                  </picture>
                                </li>
                            </ol>
                        </div>

                    </span>
                            <span v-else class="profile-image-wrapper">
                        <div class="carousel-inner w-100">
                                <div class="carousel-item active">
                                    <img class="d-block w-100" :src="noPhotoUrl" alt="First slide">
                                </div>
                        </div>
                    </span>

                        </div>

                    </div>
                    <!-- GOLD  Photos end   GOLD -->

                    <div class="main-profile-container--details d-flex flex-column d-sm-block">
                        <div class="profile-page-heading mb-3 mb-sm-4 order-first">
                            <div class="profile-page-badges"
                                 v-if="isAvailableToday || isGoldUser(user) || isVipPunterVisitor">
                                <span class="small-banner gold" v-if="isGoldUser(user)">
                                    <icon-component :icon="fa_stars()"></icon-component>
                                    {{ translate.product.gold }}
                                </span>
                                <span class="small-banner gold" v-if="isVipPunterVisitor">
                                    {{ translate.product.vip }}
                                    <icon-component width="1.25em" :icon="fa_crown()"></icon-component>
                                </span>
                                <span v-if="isAvailableToday" class="small-banner available"
                                      e2e-id="available-today-profile-banner">
                                    <icon-component :icon="fa_calendar()"></icon-component>
                                    {{ translate.account.availableToday }}
                                </span>
                            </div>

                            <div class="profile-username-row mb-4" v-if="user && user.username"
                                 :class="{'has-display-address': !!user.display_address}">
                                <h1 class="profile-username">{{ user.username }}</h1>
                                <span v-if="user.verification_status" class="small-banner verified-v2 small">
                                    <icon-component :icon="checkBadge()"/>
                                    <span>{{ translate.account.verified }}</span>
                                </span>
                                <span class="small-banner new small" v-if="isNewProfile">
                                    <icon-component :icon="fa_clock()"/>
                                    <span>{{ translate.home.new }}</span>
                                </span>

                                <a v-if="showFavoriteIcon" @click="favorite" class="small-banner favorite ml-auto">
                                    <icon-component width="14px" height="10px" :class="{'active': isFavoriteProfile}"
                                                    :icon="fa_heart_bold()"/>
                                </a>
                            </div>

                            <p class="profile-display-address" v-if="user && user.display_address">
                                {{ user.display_address }}
                            </p>

                            <venue-location-and-time :venue="user"></venue-location-and-time>
                        </div>

                        <div id="profile-page-actions-position">
                            <!-- Used to calculate correct point when make #profile-page-actions fixed on mobile -->
                        </div>
                        <div id="profile-page-actions" class="profile-page-actions mb-3 mb-sm-4 order-first">
                            <user-profile-contact-actions
                                :user="user"
                                :isSeekingServicesProfile="false"
                                @call-click="onCallClick"
                                @show-login-modal="showLoginModal"
                                :profile-is-locked="blurLockedProfile"
                                @showLockedProfileModal="showModalBlurredProfile"
                            >
                            </user-profile-contact-actions>

                            <div class="report-problem d-none d-sm-block">
                                <a href="#" @click.prevent="reportProfile">
                                    <icon-component :icon="alarm()" width="16px" height="16px"/>
                                    <span>{{ translate.account.report }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-3">
                <div class="tip-review-banners-row">
                    <div class="tip-leave-banner">
                        <span class="tip-leave-banner__text">{{ translate.home.haveYouUsedProvidedServices }}</span>
                        <a href="#" @click.prevent="openWriteReviewModal()"
                           class="btn btn-rebrand-sm btn-tip-me tip-leave-banner__button">
                            {{ translate.account.reviews.writeReview }}
                        </a>
                    </div>
                </div>
            </div>

            <map-component id="profile-map-section" @refreshMap="refreshMap"
                           :show-map="areUserCoordinatesSet"
                           :user="user"
                           :show-outcall-location="showOutcallLocation"
                           :showOutcallLocation="showOutcallsList"
                           ref="mapComponent"
            ></map-component>

            <venue-escorts
                v-if="(isGoldUser(user) || isSilverUser(user)) && lodash.get(user,'venue_users',[]).length > 0"
                :escorts="user.venue_users" :user="user">
            </venue-escorts>

            <!-- To Match UK better, this is not needed now -->
            <!--<venue-working-hours :venue="user"></venue-working-hours>-->

            <about-me id="profile-about-section" :about-me="getAboutMe()" :is-venue-profile="true"></about-me>

            <div class="col-12 mb-4 venue-features-profile-wrapper" v-if="lodash.get(user,'venueFeatures',false)">
                <venue-features :features="lodash.get(user,'venueFeatures',false)"></venue-features>
            </div>

            <reviews-component id="profile-reviews-section" v-if="user" :user="user"
                               ref="reviewsComponent"></reviews-component>

            <faq-list v-if="user" :user="user"/>
        </div>

        <!--   TODO make promoted profiles work for venue profile     -->
        <!--        <promoted-profiles-->
        <!--                v-if="showPromotedProfilesBanner()"-->
        <!--                :promotedProfiles="user.related_promoted_profiles"-->
        <!--                :promotedOnProfileResultsId="user.promoted_on_profile_results_id"-->
        <!--                @on-profile-click="onProfileClick">-->
        <!--        </promoted-profiles>-->

    </div>

</template>

<script>
import swipe from "@/scripts/jQuery/carouselSwipe";
import photoMixin from "@/components/mixins/photoMixin";
import ModalReportProfileComponent from "@/components/users/modals/ModalReportProfileComponent";
import ModalWriteReviewComponent from "@/components/users/modals/ModalWriteReviewComponent";
import userMixin from "@/components/mixins/userMixin";
import favoriteProfilesMixin from "@/components/mixins/punter/favoriteProfilesMixin";
import ProfileReviewsComponent from "@/components/users/partials/profile_reviews/ProfileReviewsComponent";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import InactiveProfileBannerComponent from "@/components/users/partials/InactiveProfileBannerComponent";
import UserProfileContactActionsComponent from "@/components/users/partials/UserProfileContactActionsComponent";
import xtrackingMixin from '@/components/mixins/xtrackingMixin';
import ExplicitPhotoPlaceholderComponent from "@/components/partials/ExplicitPhotoPlaceholderComponent";
import UserRelatedPromotedProfilesComponent from "@/components/users/partials/UserRelatedPromotedProfilesComponent";
import ModalBlurredProfileComponent from "@/components/users/ModalBlurredProfileComponent";
import VenueFeaturesInProfileComponent from "@/components/users/profile/partials/venue/VenueFeaturesInProfileComponent";
import VenueLocationAndTimeInProfileComponent
    from "@/components/users/profile/partials/venue/VenueLocationAndTimeInProfileComponent";
import VenueWorkingHoursInProfileComponent
    from "@/components/users/profile/partials/venue/VenueWorkingHoursInProfileComponent";
import userProfileMediaMixin from "@/components/mixins/profile/userProfileMediaMixin";
import FaqInProfileComponent from "@/components/users/profile/partials/FaqInProfileComponent";
import AboutMeInProfileComponent from "@/components/users/profile/partials/AboutMeInProfileComponent";
import MapInProfileComponent from "@/components/users/profile/partials/MapInProfileComponent";
import OutcallLocationInProfileComponent from "@/components/users/profile/partials/OutcallLocationInProfileComponent";
import userProfileMixin from "@/components/mixins/profile/userProfileMixin";
import VenueEscortsInProfileComponent from "@/components/users/partials/VenueEscortsInProfileComponent";
import {
    alarm,
    checkBadge,
    fa_angle_down,
    fa_angle_up,
    fa_calendar,
    fa_clock,
    fa_crown,
    fa_heart,
    fa_heart_bold,
    fa_stars,
} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import {regionRelativeUrl, isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";
import translateMixin from "@/components/mixins/translateMixin";
import ProfileHeaderNavigationComponent from "@/components/users/profile/partials/ProfileHeaderNavigationComponent.vue";
import ProfileBreadcrumbsComponent from "@/components/users/profile/partials/ProfileBreadcrumbsComponent.vue";
import ModalPunterLoginOrRegisterComponent from "@/components/global/ModalPunterLoginOrRegisterComponent.vue";
import {googleTagManager} from "@/core/utils/helpers/googleTagManager";

const data = () => ({
    lodash: _,
    store: $store,
    moment: moment,
    loadingSuccess: false,
    map: {
        holder_ref: "mapComponent.$refs.map",
        zoom: 14,
        styles: constants.user_map_style,
    },
    mapObject: null,
    noPhotoUrl: constants.user_photo.NO_PHOTO_SEARCH_URL,
    explicitThumbnailUrl: constants.user_photo.EXPLICIT_PHOTO_PLACEHOLDER_SMALL,
    explicitThumbnailVideoUrl: constants.user_photo.EXPLICIT_VIDEO_PLACEHOLDER_SMALL,
    showScrollArrows: false,
    fancyboxLoaded: false,
    fancyboxIndex: null,
    mapLoaded: false,
    unSubscribe: null,
    intervalIdentifier: null,
    intervalDebounceTime: 100,
    showAllPhotos: false,
    carouselLoadAfterInterval: 1000,
    componentInitialized: false,
});

function initializeComponent() {
    window.scrollTo(0, 0);
    swipe();

    this.initializePhotoScroll();

    $.getScript({url: regionRelativeUrl('/js/jquery.fancybox.min.js', true), cache: true}).then(() => {
        utils.injectCSS('/css/jquery.fancybox.min.css');
        this.fancyboxLoaded = true;
        if (this.fancyboxIndex !== null) {
            this.showFancybox(this.fancyboxIndex, this.user);
        }
    });

    $.getScript({url: regionRelativeUrl('/js/leaflet.js', true), cache: true}).then(() => {
        this.configureMap();
    });

    window.addEventListener('resize', this.initializePhotoScroll);
    window.addEventListener('orientationchange', this.initializePhotoScroll);
    window.addEventListener('popstate', this.refreshComponent);

    this.$nextTick(() => {
        if (typeof $('.carousel').carousel === 'function') {
            $('.carousel').carousel('dispose');
        }

        const DOMIsLoaded = /complete|interactive|loaded/.test(document.readyState);
        if (DOMIsLoaded) {
            this.showAllProfilePhotos();
        } else {
            window.addEventListener('DOMContentLoaded', (event) => {
                this.showAllProfilePhotos();
            });
        }

        this.componentInitialized = true;
    });
}

function refreshComponent() {
    if (this.mapObject) {
        this.mapObject.remove();
        this.mapObject = null;
        this.mapLoaded = false;
    }

    this.store.commit('setLoading', true);
    this.fetchUser();
}

function onProfileClick() {
    this.refreshComponent();
}

function initializeUsersData() {
    this.$emit('user-initialised', this.user);
}

function showPromotedProfilesBanner() {
    // don't show the promoted profiles banner if the user has premium (gold) or plus (silver) status
    if (this.isGoldUser(this.user) || this.isSilverUser(this.user)) {
        return false;
    }

    // show only if the related promoted profiles are loaded
    return (this.user && this.user.related_promoted_profiles && this.user.related_promoted_profiles.length > 0);
}

function onShowAllClickDesktop() {
    $([document.documentElement, document.body]).animate({scrollTop: $("#profile-features-accordion").offset().top - 100}, 400);
}

function initializePhotoScroll() {
    if (typeof window === 'undefined' || !this.user || this.isGoldUser(this.user)) {
        return;
    }

    const photosData = this.getPhotosScrollData();
    const userPhotosCount = _.get(this, 'user.photos', []).length;
    if (userPhotosCount > photosData.photosPerView) {
        this.showScrollArrows = true;
        const carouselElement = $("#profile-image-slider");
        carouselElement.off('slide.bs.carousel').on('slide.bs.carousel', (event) => {
            this.scrollToImg(event.to + 1);
        });
    }
}

function refreshMap() {
    if (this.mapObject) {
        this.mapObject._onResize();
    }
}

function openFancyBox(index, photo) {
    if (this.isMediaExplicit(photo)) {
        return;
    }

    this.fancyboxIndex = index;
    // show fancybox if it's already loaded (async)
    // otherwise, $.getScript will trigger the `showFancybox` by using `this.fancyboxIndex`
    if (this.fancyboxLoaded) {
        this.showFancybox(this.fancyboxIndex, this.user);
    }
}

function getAboutMe() {
    return _.get(this.user, 'venueFeatures.about');
}

function setTitle() {
    if (typeof document != 'undefined') {
        let title = '';
        const username = _.get(this, 'user.username', '');

        if (this.isSeekingServicesProfile && !isUnitedKingdomRegion()) {
            title = `${username} | Erobella`;
        } else {
            title = this.fillTranslateParams(
                this.translate.home.profileMetaTitle, {
                    username: username,
                    city: (_.get(this, 'user.city') || _.get(this, 'user.suburb') || this.countryName),
                    phone: (_.get(this, 'user.phone', false) && !_.get(this, 'user.phone_private', false) ? ` -${_.get(this, 'user.phone', false)}` : ''),
                });
        }

        title = title.replace('  ', ' '); // remove extra space

        document.title = title;
    }
}

function favorite() {
    googleTagManager.gtmEvent('favourite-button-click', this.user.id, this.blurLockedProfile);

    if (this.isFavoriteProfile) {
        this.trackEvent('profile', 'remove_from_favorites', 'click');
        this.removeFavoriteProfile(this.user.id);
    } else {
        this.trackEvent('profile', 'add_to_favorites', 'click');
        this.addFavoriteProfile(this.user.id);
    }
}

function openWriteReviewModal() {
    if (!this.isLoggedIn) {
        $('#modalNotLoggedIn').modal().show();
        return;
    }
    $('#modalWriteReview').modal('show');
}

export default {
    data,
    mixins: [
        photoMixin,
        userMixin,
        favoriteProfilesMixin,
        localStorageMixin,
        xtrackingMixin,
        userProfileMediaMixin,
        userProfileMixin,
        translateMixin,
    ],
    computed: {
        ...mapState([
            'translate', 'currentUser', 'countryName', 'regionData',
        ]),
        getMapHolder() {
            return _.get(this, `$refs.${this.map.holder_ref}`);
        },
        isAvailableToday() {
            return _.get(this, 'user.venueAvailableToday', false);
        },
        showOutcallsList() {
            return !_.get(this, 'regionData.sectionsToHide.venueProfileOutcallsList', false)
        },
    },
    props: {
        user: {},
    },
    watch: {
        user: {
            immediate: true,
            deep: true,
            handler() {
                if (!this.user) {
                    return;
                }
                this.initializeUsersData();
                if (typeof window !== "undefined" && this.user) {
                    this.setTitle();
                    if (!this.componentInitialized) {
                        this.initializeComponent()
                    }
                }
                _.debounce(() => {
                    this.configureMap()
                }, 200)();
            },
        },
    },
    mounted() {
        window.addEventListener("scroll", this.isFullyScrolledInView);
    },
    beforeDestroy() {
        this.store.commit('setSearchDoneFromHome', true);
        window.removeEventListener('resize', this.initializePhotoScroll);
        window.removeEventListener('orientationchange', this.initializePhotoScroll);
        window.removeEventListener('DOMContentLoaded', this.showAllProfilePhotos);
        window.removeEventListener('popstate', this.refreshComponent);
        window.removeEventListener("scroll", this.isFullyScrolledInView, {passive: true});
    },
    methods: {
        fa_clock,
        checkBadge,
        fa_stars,
        fa_calendar,
        alarm,
        fa_heart_bold,
        fa_heart,
        fa_angle_up,
        fa_crown,
        fa_angle_down,
        initializeUsersData,
        initializePhotoScroll,
        refreshMap,
        openFancyBox,
        refreshComponent,
        onProfileClick,
        showPromotedProfilesBanner,
        getAboutMe,
        setTitle,
        initializeComponent,
        favorite,
        openWriteReviewModal,
        onReviewCreated(review) {
            if (this.$refs.reviewsComponent) {
                this.$refs.reviewsComponent.updateReviews(review);
            }
        },
    },
    components: {
        ProfileHeaderNavigationComponent,
        IconComponent,
        ModalPunterLoginOrRegisterComponent,
        ModalWriteReviewComponent,
        'faq-list': FaqInProfileComponent,
        'modal-report-profile': ModalReportProfileComponent,
        'reviews-component': ProfileReviewsComponent,
        'inactive-profile-banner': InactiveProfileBannerComponent,
        'user-profile-contact-actions': UserProfileContactActionsComponent,
        'explicit-photo-placeholder': ExplicitPhotoPlaceholderComponent,
        'promoted-profiles': UserRelatedPromotedProfilesComponent,
        'modal-blurred-profile': ModalBlurredProfileComponent,
        'venue-features': VenueFeaturesInProfileComponent,
        'venue-location-and-time': VenueLocationAndTimeInProfileComponent,
        'venue-working-hours': VenueWorkingHoursInProfileComponent,
        'about-me': AboutMeInProfileComponent,
        'map-component': MapInProfileComponent,
        'outcall-location': OutcallLocationInProfileComponent,
        'venue-escorts': VenueEscortsInProfileComponent,
        ProfileBreadcrumbsComponent,
    },
};
</script>
